import { keys } from '@/utils'

export type ExternalScripts = 'static-script' | 'static-smartbanner'

export type Environment = {
  backendUrl: string
  scheme: string
}

const scriptsUrls: Record<ExternalScripts, string> = {
  'static-script': '/web-static.js', // normally served from static.*.chapi.to, if 'url' is not given to load() it will use a local script file
  'static-smartbanner': '/smartbanner.js', // same as above
}

const loadedScripts = new Map<ExternalScripts, HTMLScriptElement>()

export const ExternalScriptsService = {
  load(
    script: ExternalScripts,
    options?: { explicitUrl?: string; attributes?: Record<string, string> },
  ): { script: HTMLScriptElement; alreadyLoaded: boolean } {
    if (loadedScripts.has(script)) {
      return { script: loadedScripts.get(script)!, alreadyLoaded: true }
    }

    const scriptElement = document.createElement('script')
    const baseUrl = options?.explicitUrl ?? scriptsUrls[script]
    scriptElement.src = import.meta.env.DEV
      ? `${baseUrl}?t=${Date.now()}`
      : baseUrl
    if (options?.attributes) {
      for (const key of keys(options.attributes)) {
        scriptElement.setAttribute(key.toString(), options.attributes[key])
      }
    }
    document.head.appendChild(scriptElement)
    loadedScripts.set(script, scriptElement)
    return { script: scriptElement, alreadyLoaded: false }
  },

  getMobilePreviewEnvironment(): Environment {
    return {
      backendUrl: window.location.host,
      scheme: window.location.protocol.replace(':', ''),
    }
  },
}
